import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { todayStr, dayLabel } from './routeDate';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Hele rit van een chauffeur naar een andere dag verplaatsen.
export const MoveDayButton = ({ driver, date, token, onMoved }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const move = async (to) => {
    if (!to || to === date) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/chauffeur-move-day`, { driver, from_date: date, to_date: to },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`${data.moved} motor(en) van ${driver} verplaatst naar ${dayLabel(to).toLowerCase()} (${new Date(`${to}T12:00:00`).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })})`);
      onMoved(to);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Verplaatsen mislukt');
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="relative block w-full mt-1.5">
      <button type="button" disabled={busy} onClick={() => { const el = ref.current; if (el?.showPicker) el.showPicker(); else el?.focus(); }}
              className="w-full text-xs px-2 py-1.5 bg-white hover:bg-blue-50 border border-blue-300 text-blue-800 rounded font-semibold disabled:opacity-50"
              data-testid={`driver-move-day-${driver}-${date}`}>
        📅 {busy ? 'Verplaatsen…' : 'Andere dag'}
      </button>
      <input ref={ref} type="date" min={todayStr()} defaultValue={date} onChange={(e) => move(e.target.value)}
             className="absolute inset-0 opacity-0 pointer-events-none" tabIndex={-1}
             data-testid={`driver-move-day-input-${driver}-${date}`} />
    </label>
  );
};
